import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<any, { tournamentId: number; teamId: number }>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/teams/${body.teamId}`,
      method: 'DELETE',
    }),
  });
